<template>
    <div>
        <span>{{ moment(date).format('DD-MM-YYYY') }}</span><br>
        at <span>{{ moment(date).format('HH:mm') }}</span>
    </div>
</template>

<script>
    import moment from 'moment';
    export default {
        props:{
            date:{},
        },
        
        data() {
            return {
                moment:moment,
            }
        },
        
    }
</script>

<style lang="scss" scoped>

</style>